export default "__VITE_ASSET__6b7dc8f5__"